module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "full-height field-editor",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": "",
      "color": "#89C6E3",
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n  ")]), _vm._v(" "), _c('v-row', {
    staticClass: "custom-scroll-bar field-editor-row",
    staticStyle: {
      "position": "absolute",
      "width": "95%",
      "height": "90%"
    }
  }, [_c('v-col', {
    staticStyle: {
      "text-align": "-webkit-center"
    },
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-img', {
    attrs: {
      "max-height": "124",
      "max-width": "124",
      "src": require('@/assets/min-field.png')
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('span', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('FieldEditor.fieldData')))]), _vm._v(" "), _c('v-form', {
    ref: "fieldForm",
    staticClass: "mt-7",
    model: {
      value: (_vm.isFormValid),
      callback: function($$v) {
        _vm.isFormValid = $$v
      },
      expression: "isFormValid"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('FieldEditor.fieldName')) + " *"),
      "title": ((_vm.$t('FieldEditor.fieldName')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": [function (v) { return !!v || _vm.$t('Config.fieldIsRequired'); }],
      "required": "",
      "maxlength": "30",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.fieldData.name),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "name", $$v)
      },
      expression: "fieldData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-5",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.primaryUsers,
      "item-text": function (e) { return ((e.name) + " " + (e.lastName)); },
      "item-value": "id",
      "label": ((_vm.$t('FieldEditor.fieldContact')) + " *"),
      "title": ((_vm.$t('FieldEditor.fieldContact')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": [function (v) { return !!v || _vm.$t('Config.fieldIsRequired'); }],
      "required": "",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([(_vm.comesFromAnotherRoute && _vm.comesFromAnotherRouteName === 'NewCampaignInitialData') ? {
      key: "append-item",
      fn: function() {
        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.addNewUser('contact')
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "add-field-btn"
        }, [_vm._v("\n                    + " + _vm._s(_vm.$t('FieldEditor.addNewUser')) + "\n                  ")])], 1)]
      },
      proxy: true
    } : null], null, true),
    model: {
      value: (_vm.fieldData.contact),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "contact", $$v)
      },
      expression: "fieldData.contact"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-5",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "items": _vm.secondaryUsers,
      "item-text": function (e) { return ((e.name) + " " + (e.lastName)); },
      "item-value": "id",
      "label": ("" + (_vm.$t('FieldEditor.fieldAuxContact'))),
      "title": ("" + (_vm.$t('FieldEditor.fieldAuxContact'))),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "hide-details": "auto"
    },
    scopedSlots: _vm._u([(_vm.comesFromAnotherRoute && _vm.comesFromAnotherRouteName === 'NewCampaignInitialData') ? {
      key: "append-item",
      fn: function() {
        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.addNewUser('auxContact')
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "add-field-btn"
        }, [_vm._v("\n                    + " + _vm._s(_vm.$t('FieldEditor.addNewUser')) + "\n                  ")])], 1)]
      },
      proxy: true
    } : null], null, true),
    model: {
      value: (_vm.fieldData.auxContact),
      callback: function($$v) {
        _vm.$set(_vm.fieldData, "auxContact", $$v)
      },
      expression: "fieldData.auxContact"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "aux-contact-subtitle pt-3"
  }, [_vm._v(_vm._s(_vm.$t('FieldEditor.auxContactSubtitle')))])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "text-h6 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('FieldEditor.gates')))]), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "10"
    }
  }, [(_vm.fieldData.gates) ? _c('div', [_vm._l((_vm.fieldData.gates), function(point, pointIndex) {
    return _c('v-row', {
      key: ("point_" + pointIndex),
      staticClass: "align-start"
    }, [_c('v-col', {
      staticClass: "py-1 d-none d-md-block",
      attrs: {
        "cols": "5"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$t('AddDevice.latitude')) + " *"),
        "title": ((_vm.$t('AddDevice.latitude')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "dense": "",
        "hint": ("" + (_vm.$t('FieldEditor.coordinatesHint'))),
        "flat": "",
        "rules": [function (v) { return (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || _vm.$t('Config.onlyNumbers'); }, function (v) { return (v === '' || v === null || v === undefined) || (v <= 90 && v >= -90) || _vm.$t('Config.latitudeRule'); }],
        "hide-details": "auto",
        "persistent-hint": "",
        "validate-on-blur": ""
      },
      model: {
        value: (point.latitude),
        callback: function($$v) {
          _vm.$set(point, "latitude", _vm._n($$v))
        },
        expression: "point.latitude"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "py-1 d-none d-md-block",
      attrs: {
        "cols": "5"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$t('AddDevice.longitude')) + " *"),
        "title": ((_vm.$t('AddDevice.longitude')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "dense": "",
        "hint": ("" + (_vm.$t('FieldEditor.coordinatesHint'))),
        "flat": "",
        "rules": [function (v) { return (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || _vm.$t('Config.onlyNumbers'); }, function (v) { return (v === '' || v === null || v === undefined) || (v <= 180 && v >= -180) || _vm.$t('Config.longitudeRule'); }],
        "hide-details": "auto",
        "persistent-hint": "",
        "validate-on-blur": ""
      },
      model: {
        value: (point.longitude),
        callback: function($$v) {
          _vm.$set(point, "longitude", _vm._n($$v))
        },
        expression: "point.longitude"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "py-1 d-none d-md-flex justify-center align-center",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-btn', {
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": "1",
        "color": "#FFF"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGatePoint(pointIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "black"
      }
    }, [_vm._v("remove")])], 1)], 1), _vm._v(" "), _c('v-col', {
      staticClass: "py-1 d-block d-md-none",
      attrs: {
        "cols": "12"
      }
    }, [_c('v-row', {
      staticClass: "align-stretch"
    }, [_c('v-col', {
      attrs: {
        "cols": "10"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": ((_vm.$t('AddDevice.latitude')) + " *"),
        "title": ((_vm.$t('AddDevice.latitude')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "dense": "",
        "hint": ("" + (_vm.$t('FieldEditor.coordinatesHint'))),
        "flat": "",
        "rules": [function (v) { return (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || _vm.$t('Config.onlyNumbers'); }, function (v) { return (v === '' || v === null || v === undefined) || (v <= 90 && v >= -90) || _vm.$t('Config.latitudeRule'); }],
        "hide-details": "auto",
        "validate-on-blur": ""
      },
      model: {
        value: (point.latitude),
        callback: function($$v) {
          _vm.$set(point, "latitude", _vm._n($$v))
        },
        expression: "point.latitude"
      }
    }), _vm._v(" "), _c('v-text-field', {
      staticClass: "mt-2",
      attrs: {
        "label": ((_vm.$t('AddDevice.longitude')) + " *"),
        "title": ((_vm.$t('AddDevice.longitude')) + " *"),
        "outlined": "",
        "background-color": "#FFF",
        "color": "#0098E1",
        "dense": "",
        "hint": ("" + (_vm.$t('FieldEditor.coordinatesHint'))),
        "flat": "",
        "rules": [function (v) { return (v === '' || v === null || v === undefined) || /^[+|-]?\d+([.]\d+)?$/.test(v) || _vm.$t('Config.onlyNumbers'); }, function (v) { return (v === '' || v === null || v === undefined) || (v <= 180 && v >= -180) || _vm.$t('Config.longitudeRule'); }],
        "hide-details": "auto",
        "validate-on-blur": ""
      },
      model: {
        value: (point.longitude),
        callback: function($$v) {
          _vm.$set(point, "longitude", _vm._n($$v))
        },
        expression: "point.longitude"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "d-flex justify-center mt-5",
      attrs: {
        "cols": "2"
      }
    }, [_c('v-btn', {
      attrs: {
        "fab": "",
        "x-small": "",
        "elevation": "1",
        "color": "#FFF"
      },
      on: {
        "click": function($event) {
          return _vm.deleteGatePoint(pointIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "black"
      }
    }, [_vm._v("remove")])], 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-row', {
    staticClass: "justify-start",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "x-small": "",
      "elevation": "1",
      "color": "#FFF"
    },
    on: {
      "click": _vm.addGatePoint
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#0098E1"
    }
  }, [_vm._v("add")])], 1), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.$t('AddDevice.addPoint')))])], 1)], 2) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "align-self": "end"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-column align-center",
    attrs: {
      "cols": "10",
      "offset": "1",
      "sm": "4",
      "offset-sm": "4"
    }
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "block": "",
      "color": "#0098E1",
      "large": "",
      "disabled": !(_vm.isFormValid && _vm.fieldData.gates.length),
      "dark": !!(_vm.isFormValid && _vm.fieldData.gates.length),
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('FieldEditor.register')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4883d5aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/AddField/FieldEditor.vue
// module id = 1717
// module chunks = 0